import { render, staticRenderFns } from "./password2.vue?vue&type=template&id=0f70be68&"
import script from "./password2.vue?vue&type=script&lang=js&"
export * from "./password2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports